export default __webpack_public_path__ + "static/media/FacturacionIconYellow.ca287f31.svg";